import { gql } from "@apollo/client";
import { AtlasButtonProps } from "@resource/atlas";
import { PrimaryColor } from "@resource/common";
import clsx from "clsx";
import PreviewGuideHeader from "components/SetupWizard/PreviewGuideHeader";
import contrast from "contrast";
import { OrganizationThemedPreviewContainerOrganization } from "generated/schemaTypes";
import { useMemo } from "react";

const ORGANIZATION_FRAGMENT = gql`
  fragment OrganizationThemedPreviewContainerOrganization on Organization {
    theme {
      primaryColor
      secondaryColor
    }
  }
`;

type OrganizationThemedPreviewContainerProps = {
  organization?: OrganizationThemedPreviewContainerOrganization | null;
  previewUrl?: string;
  className?: string;
  showHeader?: boolean;
  children?: React.ReactNode;
};
function OrganizationThemedPreviewContainer({
  organization,
  previewUrl,
  className,
  showHeader = false,
  children,
}: OrganizationThemedPreviewContainerProps) {
  const trimColor = organization?.theme?.primaryColor ?? PrimaryColor;
  const orgThemeBackgroundButtonVariant = useMemo(
    (): AtlasButtonProps["variant"] =>
      contrast(trimColor) === "light" ? "dark" : "light",
    [trimColor]
  );

  return (
    <div
      className={clsx(className, "relative")}
      style={{
        background: `linear-gradient(180deg, ${trimColor} 0%, ${trimColor} 10rem, #fafafa 10rem, #fafafa 100%)`,
      }}
    >
      {showHeader && (
        <PreviewGuideHeader
          variant={orgThemeBackgroundButtonVariant}
          previewUrl={previewUrl}
        />
      )}
      {children}
    </div>
  );
}

OrganizationThemedPreviewContainer.fragments = {
  organization: ORGANIZATION_FRAGMENT,
};

export default OrganizationThemedPreviewContainer;
